/**
 * @generated SignedSource<<bb939ed30ff6ba50b14702d8011d102a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionPicker_VersionPicker_jiraIssue" | "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue">;
  readonly " $fragmentType": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue";
};
export type ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue$key = {
  readonly " $data"?: ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "a7d48e98e04811f2286b41cb01a9419a";

export default node;
